import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import amountFormat from "../../../../utils/amountFormat";

function WithdrawDescription(props) {
    const {withdrawalAmount} = props;
    const {getLangPath} = useLangContext();

    return <div className={'d-flex justify-content-between'}>
        <span>{getLangPath('withdrawal.available_for_withdrawal')}</span>
        <span>${amountFormat(withdrawalAmount, 2)}</span>
    </div>
}

export default WithdrawDescription;
